import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "profile-picker_list" }
const _hoisted_2 = {
  key: 1,
  class: "text-center q-mb-lg"
}
const _hoisted_3 = { class: "s-text-description q-mt-md" }
const _hoisted_4 = ["href"]

import UserProfileItem from 'components/Auth/UserProfileItem.vue';
import { computed } from 'vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { UserProfileBare } from 'SharedDir/declarations/user-profiles';
import { useUserStore } from 'SharedDir/stores/user.store';
import { LK_GOSUSLUGI_ROLES } from 'SharedDir/constants/contacts';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ProfilePicker' },
  __name: 'ProfilePicker',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const userStore = useUserStore();
const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits);

const set = (profile) => {
  innerValue.value = profile;
  emitValue();
};

const profiles = computed(() => userStore.userProfiles);
const hasProfiles = computed(() => profiles.value.length > 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (hasProfiles.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(profiles.value, (profile, index) => {
          return (_openBlock(), _createBlock(UserProfileItem, {
            key: index,
            data: profile,
            class: _normalizeClass({ active: _unref(innerValue) && profile.id === _unref(innerValue).id }),
            onClick: ($event: any) => (set(profile))
          }, null, 8, ["data", "class", "onClick"]))
        }), 128))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text__headline3" }, " Отсутствуют сведения по организациям/профилям, которые могут быть использованы в системе ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode(" Проверьте, привязано ли Ваше Юридическое лицо на сайте ")),
            _createElementVNode("a", {
              class: "s-link",
              href: _unref(LK_GOSUSLUGI_ROLES),
              target: "_blank",
              rel: "noopener noreferrer"
            }, " Государственных услуг ", 8, _hoisted_4)
          ])
        ]))
  ]))
}
}

})